import React, { useState } from 'react'
import { Modal, Row, Col, Button, Avatar, message } from 'antd'
import axios from 'axios'
import _ from 'lodash'
import PickMaterial from '../PickMaterial'
import PickMaterialSecond from '../MaterialLinkListForm'
import { useDeepEffect } from '../../../utils/hooks'

const MaterialLinkForm = (props) => {
  const { action, visible, onCancel, formData, productLinkList } =
    props
  const [openModal, setOpenModal] = useState(false)
  const [openModalSec, setOpenModalSec] = useState(false)
  const [materialPick, setMaterialPick] = useState(null)
  const [categories, setCategories] = useState([])
  const [materialLinkList, setMaterialLinkList] = useState([])

  useDeepEffect(() => {
    if (action === 'Edit') {
      setMaterialPick(formData.material)
      setMaterialLinkList(formData.linkMaterial)
    }
    fetchCategories()
  }, [formData])

  async function fetchCategories() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/product/groupByCategory`
      )
      setCategories(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  console.log(categories)

  const onClick = () => {
    setOpenModal(true)
  }

  const onClickSec = () => {
    setOpenModalSec(true)
  }

  const onClose = () => {
    setOpenModal(false)
    setOpenModalSec(false)
  }

  const onSave = async () => {
    try {
      const data = {
        linkMaterialIdList: materialLinkList.map((item) => item.id),
        materialId: materialPick.id
      }

      const token = localStorage.getItem('user-token')

      await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/product/linkMaterial`,
        data,
        {
          headers: {
            Authorization: !_.isNull(token) ? token : ''
          }
        }
      )
      message.success('บันทึกสำเร็จ')
      onCancel()
    } catch (err) {
      message.error('บันทึกไม่สำเร็จ')
    }
  }

  const onDelete = (record) => {
    setMaterialLinkList((prevState) => {
      let arr = []
      arr = prevState.filter((item) => item.id !== record.id)
      return arr
    })
  }

  return (
    <Modal
      title={`${action} Product Link`}
      visible={visible}
      destroyOnClose
      onCancel={onCancel}
      onOk={onSave}
      width={800}>
      <Row type="flex" gutter={8}>
        <Col>
          <span>เลือกวัสดุหลัก</span>
        </Col>
        <Col>
          <Button size="small" icon="plus" onClick={() => onClick()} />
        </Col>
      </Row>
      {materialPick && true && (
        <Row type="flex" gutter={8}>
          <Col>
            <Avatar src={materialPick.cover.url} size={48} />
          </Col>
          <Col>
            <span style={{ lineHeight: '45px' }}>{materialPick.name}</span>
          </Col>
        </Row>
      )}
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button size="small" onClick={() => onClickSec()}>
            เพิ่มวัสดุรอง
          </Button>
        </Col>
      </Row>
      {materialLinkList.map((item, index) => {
        return (
          <div key={index}>
            <hr />
            <Row>
              <span>{`วัสดุรอง ${index + 1}`}</span>
            </Row>
            <Row key={index} type="flex">
              <Col span={20}>
                <Row type="flex" gutter={8}>
                  <Col>
                    <Avatar src={item.cover.url} size={48} />
                  </Col>
                  <Col>
                    <span style={{ lineHeight: '45px' }}>{item.name}</span>
                  </Col>
                </Row>
              </Col>
              <Col span={4}>
                <Row type="flex" justify="end">
                  <Button type="danger" onClick={() => onDelete(item)}>
                    ลบ
                  </Button>
                </Row>
              </Col>
            </Row>
          </div>
        )
      })}
      {openModal ? (
        <PickMaterial
          productLinkList={productLinkList}
          visible={openModal}
          categories={categories}
          onClose={onClose}
          materialPick={materialPick}
          setMaterialPick={setMaterialPick}
        />
      ) : null}
      {openModalSec ? (
        <PickMaterialSecond
          visible={openModalSec}
          categories={categories}
          onClose={onClose}
          materialLinkList={materialLinkList}
          setMaterialLinkList={setMaterialLinkList}
        />
      ) : null}
    </Modal>
  )
}

export default MaterialLinkForm



// WEBPACK FOOTER //
// ./src/pages/MaterialLink/MaterialLinkForm/index.js